module.exports = __webpack_public_path__ + "02_mid_brown.2534e45c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_mid_brown.png
// module id = 5atn
// module chunks = 0